/** Hash fragments from the former single-page site → real routes. */
export const HASH_REDIRECTS: Record<string, string> = {
  collection: "/collection",
  personalization: "/personalization",
  about: "/about",
  reviews: "/about#reviews",
  contact: "/contact",
  top: "/",
};

/** Inline script so old /#collection bookmarks redirect before paint. */
export const HASH_REDIRECT_SCRIPT = `(function(){var m=${JSON.stringify(HASH_REDIRECTS)};var h=location.hash.replace(/^#/,"");var to=m[h];if(to&&location.pathname==="/")location.replace(to);})();`;

/**
 * gtag parses into ~100ms+ long tasks on the main thread. Do not load it from
 * idle/scroll during initial load (that still lands inside Lighthouse TBT).
 * Wait for a real input gesture, with a late fallback for non-interactive visits.
 */
export const DEFERRED_GTAG_SCRIPT = `(function(){var loaded=false,events=["pointerdown","keydown","touchstart"];function load(){if(loaded)return;loaded=true;events.forEach(function(e){window.removeEventListener(e,load,{capture:true});});var s=document.createElement("script");s.src="https://www.googletagmanager.com/gtag/js?id=G-2BMSGQHLYX";s.async=true;document.head.appendChild(s);window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}window.gtag=gtag;gtag("js",new Date());gtag("config","G-2BMSGQHLYX");}events.forEach(function(e){window.addEventListener(e,load,{once:true,passive:true,capture:true});});setTimeout(load,12000);})();`;
